import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d4266b66"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d4266b66&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4266b66')) {
      api.createRecord('d4266b66', component.options)
    } else {
      api.reload('d4266b66', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d4266b66", function () {
      api.rerender('d4266b66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/audioPlay/index.vue"
export default component.exports